
/*
Defines the custom element <ravel-slider-2>
*/

import { RavelSlider2 } from './src/RavelSlider2.js';

customElements.define('ravel-slider-2', RavelSlider2);
